import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mt-10" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增项目")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("批量设置")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("根据人员搜索")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("未设置研发项目成员")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("新增成员")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("更新")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("删除")

import {ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix, { userCfig } from '@/global_mixin/tableMixin'
import { formatNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  // 获取项目
  'GET/projects': fetchList,
  // 新增-项目
  'POST/projects': addProjectApi, 
  // 删除项目
  'DELETE/projects/{id}': delProjectApi,
  // 项目更新（编辑）
  'PATCH/projects': updataProjectApi,
  // 获取-项目成员列表
  'POST/project_members/list': fetchMembersApi,
  // 新增-项目成员
  'POST/project_members': addMembersApi,
  // 更新-项目成员
  'PATCH/project_members': updataMemberApi,
  // 删除项目成员
  'DELETE/project_members/{id}': delMenberApi,
  // 所有角色
  'GET/users/list': userListApi,
  // 设置人员批量归属项目
  'POST/project_members/batch_set': batch_setApi,
  // 根据人员获取所在项目
  'GET/projects/user': projectsUserApi,
  // 获取未设置研发项目人员
  'GET/projects/unset': unsetApi,
} = Api

let fullUserList: any = ref([])
onBeforeMount(() => {
  userListApi().then((_userList: object[]) => {
    fullUserList.value = _userList.map((_user: any) => {
      _user.label = `${_user.realName}(${_user.alias})`
      return _user
    })
  })
})

let projectRows = ref([])
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)
fetchData()

const { 
  MI_tableData: memberData, fetchData: fetchMember, page: memberPage, size: memberSize, MI_total: memberTotal,
  MI_pageChange: memberPgCg, MI_sizeChange: memberSzCg, MI_identify: memberIdentify, MI_params: memberParams
} = new tbMix(fetchMembersApi)

let projectRow: any = ref({})
const showProjectMenber = (row: any) => {
  if(!row){
    return
  }
  projectRow.value = row
  // 展示项目成员
  fetchMember({
    projectId: row.id
  })
}

// 根据人员，搜索项目
const searchFg = ref<boolean>(false)
const searchConfig = ref([
  userCfig(),
])
const searchMenberProject = () => {
  MI_modifyForm({}, searchConfig, searchFg, async(params: any) => {
    let projectList = await projectsUserApi(params)
    MI_tableData.value = projectList
    ElMessage.success('搜索成功')
    searchFg.value = false
  })
}
// 添加
const addConfig = ref([
  {
    label: '项目名',
    value: '',
    upKey: 'name',
    rule: [{ required: true, message: '请输入项目名', trigger: 'change' }],
    props: {
      placeholder: "请输入项目名"
    }
  },
  {
    label: '项目ID',
    value: '',
    upKey: 'purpose',
    rule: [{ required: true, message: '请输入项目ID', trigger: 'change' },
    { validator: (rule: any, value: any, callback: any) => {
      if(!/^[a-zA-Z]+$/.test(value)){
        callback(new Error('请输入纯英文项目ID'))
      }
      callback()
    }, trigger: 'change' }],
    props: {
      placeholder: "请输入纯英文ID"
    }
  },
  {
    type: "TIME",
    label: "开始时间",
    value: '',
    upKey: 'startDate',
    rule: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
    props: {
      type: 'date',
      clearable: false,
      'value-format': 'YYYY-MM-DD',
    }
  },
  {
    type: "TIME",
    label: "结束时间",
    value: '',
    upKey: 'endDate',
    props: {
      type: 'date',
      clearable: false,
      'value-format': 'YYYY-MM-DD',
    }
  },
  {
    label: '备注',
    value: '',
    upKey: 'note',
    props: {
      type: 'textarea',
      placeholder: "请输入备注"
    }
  },
])
const addFg = ref<boolean>(false)
const addHandle = () => {
  MI_modifyForm({}, addConfig, addFg, async(params: any) => {
    if(!/^[a-zA-Z]+$/.test(params.purpose)){
      ElMessage.warning('请输入纯英文项目ID')
      return
    }
    await addProjectApi(params)
    ElMessage.success('成功')
    addFg.value = false
    fetchData(MI_params)
  })
}

// 修改
const modifyConfig = ref([
  {
    label: '项目名',
    value: '',
    upKey: 'name',
    rule: [{ required: true, message: '请输入项目名', trigger: 'change' }],
    props: {
      placeholder: "请输入项目名"
    }
  },
  {
    type: "TIME",
    label: "开始时间",
    value: '',
    upKey: 'startDate',
    rule: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
    props: {
      type: 'date',
      clearable: false,
      'value-format': 'YYYY-MM-DD',
    }
  },
  {
    type: "TIME",
    label: "结束时间",
    value: '',
    upKey: 'endDate',
    props: {
      type: 'date',
      clearable: false,
      'value-format': 'YYYY-MM-DD',
    }
  },
  {
    label: '备注',
    value: '',
    upKey: 'note',
    props: {
      type: 'textarea',
      placeholder: "请输入备注"
    }
  },
])
const modifyFg = ref<boolean>(false)
const modifyHandle = (row: any) => {
  MI_modifyForm(row, modifyConfig, modifyFg, async(params: any) => {
    await updataProjectApi({
      ...params,
      id: row.id
    })
    ElMessage.success('成功')
    modifyFg.value = false
    fetchData(MI_params)
  })
}

// 删除
const delHandle = (row: any) => {
  ElMessageBox.confirm(
    '是否删除该项目?',
    '提示',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    MI_identify.value = true
    return delProjectApi({id: row.id})
  }).then(() => {
    MI_identify.value = false
    fetchData(MI_params)
  }).catch(() => {
    MI_identify.value = false
  })
}

// 项目添加成员
const addMemberFg = ref<boolean>(false) 
const addMemberConfig = ref([
  {
    type: 'SELECT',
    label: '员工',
    value: '',
    upKey: 'userId',
    rule: [{ required: true, message: '请选择员工', trigger: 'change' }],
    options: fullUserList,
    placeholder: '请选择员工',
    props: { disabled: false },
    seleProps: {
      label: 'label',
      valueName: 'userId',
    }
  },
  {
    type: "TIME",
    label: "入项时间",
    value: '',
    upKey: 'startDate',
    rule: [{ required: true, message: '请选择入项时间', trigger: 'change' }],
    props: {
      type: 'date',
      clearable: false,
      'value-format': 'YYYY-MM-DD',
    }
  },
  {
    type: "TIME",
    label: "离项时间",
    value: '',
    upKey: 'endDate',
    props: {
      type: 'date',
      clearable: false,
      'value-format': 'YYYY-MM-DD',
    }
  },
])
const addMember = (row: any) => {
  MI_modifyForm({}, addMemberConfig, addMemberFg, async(params: any) => {
    await addMembersApi({
      ...params,
      projectId: row.id
    })
    ElMessage.success('添加成功')
    addMemberFg.value = false
    // 刷新项目成员
    fetchMember({
      projectId: row.id
    })
    fetchData(MI_params)
  })
}

// 批量设置
const batchSetFg = ref<boolean>(false)
const batchSetConfig = ref([
  {
    type: 'SELECT',
    label: '员工',
    value: '',
    upKey: 'userId',
    rule: [{ required: true, message: '请选择员工', trigger: 'change' }],
    options: fullUserList,
    placeholder: '请选择员工',
    props: { disabled: false },
    seleProps: {
      label: 'label',
      valueName: 'userId',
    }
  },
  {
    type: "TIME",
    label: "入项时间",
    value: '',
    upKey: 'startDate',
    rule: [{ required: true, message: '请选择入项时间', trigger: 'change' }],
    props: {
      type: 'date',
      clearable: false,
      'value-format': 'YYYY-MM-DD',
    }
  },
  {
    type: "TIME",
    label: "离项时间",
    value: '',
    upKey: 'endDate',
    props: {
      type: 'date',
      clearable: false,
      'value-format': 'YYYY-MM-DD',
    }
  },
])
const batchSetHandle = () => {
  if(projectRows.value.length === 0){
    ElMessage.warning('请至少选择一个项目')
    return
  }
  MI_modifyForm({}, batchSetConfig, batchSetFg, async(params: any) => {
    await batch_setApi({
      projectIds: projectRows.value.map((e: {id: string}) => e.id),
      ...params,
    })
    ElMessage.success('添加成功')
    batchSetFg.value = false
    // 刷新项目成员
    fetchMember(memberParams)
    fetchData(MI_params)
  })
}



// ------------更新项目成员------------
const updataMemberFg = ref<boolean>(false)
const updataMemberConfig = ref([
{
    type: 'SELECT',
    label: '员工',
    value: '',
    upKey: 'userId',
    options: fullUserList,
    placeholder: '请选择员工',
    props: { disabled: true },
    seleProps: {
      label: 'label',
      valueName: 'userId',
    }
  },
  {
    type: "TIME",
    label: "入项时间",
    value: '',
    upKey: 'startDate',
    rule: [{ required: true, message: '请选择入项时间', trigger: 'change' }],
    props: {
      type: 'date',
      clearable: false,
      'value-format': 'YYYY-MM-DD',
    }
  },
  {
    type: "TIME",
    label: "离项时间",
    value: '',
    upKey: 'endDate',
    props: {
      type: 'date',
      clearable: false,
      'value-format': 'YYYY-MM-DD',
    }
  },
])
const updataMemberHandle = (row: any) => {
  MI_modifyForm(row, updataMemberConfig, updataMemberFg, async(params: any) => {
    await updataMemberApi({
      ...params,
      id: row.id,
      projectId: projectRow.value.id,
    })
    ElMessage.success('添加成功')
    updataMemberFg.value = false
    fetchMember(memberParams)
  })
}

// 删除成员
const delMenberHandle = (row: any) => {
  ElMessageBox.confirm(
    '是否删除该成员?',
    '提示',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    memberIdentify.value = true
    return delMenberApi({id: row.id})
  }).then(() => {
    memberIdentify.value = false
    fetchMember(memberParams)
    fetchData(MI_params)
  }).catch(() => {
    memberIdentify.value = false
  })
}


// 获取未设置研发项目人员
const isShowUnset = ref<boolean>(false)
let unsetList: any = ref([])
const showUnsetMenber = () => {
  MI_identify.value = true
  unsetApi().then((rep) => {
    unsetList.value = rep
    MI_identify.value = false
    isShowUnset.value = true
  }).catch(() => {
    MI_identify.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (addHandle()))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (batchSetHandle()))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (searchMenberProject()))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: showUnsetMenber }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              icon: "refresh",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(fetchData)())),
              type: "info"
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              class: "mt-10",
              ref: "tb",
              border: "",
              data: _unref(MI_tableData),
              onSelectionChange: _cache[4] || (_cache[4] = (rows) => _isRef(projectRows) //@ts-ignore
 ? projectRows.value = rows : projectRows = rows),
              onCurrentChange: showProjectMenber,
              "max-height": _unref(MI_height) + 'px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: "55"
                }),
                _createVNode(_component_el_table_column, {
                  label: "项目(可点击)",
                  prop: "name",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "开始时间",
                  prop: "startDate",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "结束时间",
                  prop: "endDate",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "成员数",
                  prop: "memberNumber",
                  align: "right"
                }),
                _createVNode(_component_el_table_column, {
                  label: "备注",
                  prop: "note",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  width: "200"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_link, {
                          type: "primary",
                          onClick: ($event: any) => (modifyHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_link, {
                          onClick: ($event: any) => (addMember(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_link, {
                          type: "danger",
                          onClick: ($event: any) => (delHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "max-height"])), [
              [_directive_loading, _unref(MI_identify)]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tag, {
              type: "warning",
              class: "mt-10 mb-10"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 当前查看项目：" + _toDisplayString(_unref(projectRow).name || '-'), 1)
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              class: "mt-10",
              border: "",
              data: _unref(memberData),
              "max-height": _unref(MI_height) + 'px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "成员",
                  prop: "realName",
                  "show-overflow-tooltip": ""
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.realName + ' (' + row.alias + ')'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "入项时间",
                  prop: "startDate",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "离项时间",
                  prop: "endDate",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  width: "200"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_link, {
                          type: "primary",
                          onClick: ($event: any) => (updataMemberHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_link, {
                          type: "danger",
                          onClick: ($event: any) => (delMenberHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "max-height"])), [
              [_directive_loading, _unref(memberIdentify)]
            ]),
            _createVNode(_component_el_pagination, {
              small: "",
              background: "",
              total: _unref(memberTotal),
              currentPage: _unref(memberPage),
              "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => (_isRef(memberPage) ? (memberPage).value = $event : null)),
              "page-size": _unref(memberSize),
              "onUpdate:page-size": _cache[6] || (_cache[6] = ($event: any) => (_isRef(memberSize) ? (memberSize).value = $event : null)),
              class: "mb-5 mt-5",
              "page-sizes": [10, 30, 50],
              layout: "sizes, prev, pager, next, total, jumper",
              onCurrentChange: _unref(memberPgCg),
              onSizeChange: _unref(memberSzCg)
            }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      title: "创建项目",
      modelValue: addFg.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((addFg).value = $event))
    }, {
      default: _withCtx(() => [
        (addFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: addConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "维护项目",
      modelValue: modifyFg.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((modifyFg).value = $event))
    }, {
      default: _withCtx(() => [
        (modifyFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: modifyConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "添加成员",
      modelValue: addMemberFg.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((addMemberFg).value = $event))
    }, {
      default: _withCtx(() => [
        (addMemberFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: addMemberConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "更新项目成员",
      modelValue: batchSetFg.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((batchSetFg).value = $event))
    }, {
      default: _withCtx(() => [
        (batchSetFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: batchSetConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "批量设置人员项目归属",
      modelValue: updataMemberFg.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((updataMemberFg).value = $event))
    }, {
      default: _withCtx(() => [
        (updataMemberFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: updataMemberConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      draggable: "",
      width: "750",
      modelValue: searchFg.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((searchFg).value = $event)),
      title: "搜索员工所在项目(可拖动)"
    }, {
      default: _withCtx(() => [
        (searchFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: searchConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "690",
      modelValue: isShowUnset.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((isShowUnset).value = $event)),
      title: "未设置研发项目人员"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          border: "",
          data: _unref(unsetList),
          "max-height": "500px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { label: "姓名" }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", null, _toDisplayString(`${row.realName}(${row.alias})`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "邮箱",
              prop: "email"
            }),
            _createVNode(_component_el_table_column, {
              label: "手机号码",
              prop: "phoneNumber"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})